import { render, staticRenderFns } from "./BCSelCallGeneral.vue?vue&type=template&id=1237366b&scoped=true"
import script from "./BCSelCallGeneral.vue?vue&type=script&lang=js"
export * from "./BCSelCallGeneral.vue?vue&type=script&lang=js"
import style0 from "./BCSelCallGeneral.vue?vue&type=style&index=0&id=1237366b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1237366b",
  null
  
)

export default component.exports